import { render, staticRenderFns } from "./HeaderWishlist.vue?vue&type=template&id=7848af06&"
import script from "./HeaderWishlist.vue?vue&type=script&lang=js&"
export * from "./HeaderWishlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports